module.exports = require("urijs");